export default "__VITE_ASSET__7d6ABzZ0__"